import React, { Fragment, useEffect, useState } from "react";
import { Input, Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import moment from "moment";
import api from "../../../apis/api";
import Notifications from "../../../components/common/Notifications";
import SelectBoxSearch from "../../common/SelectBoxSearch";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
import "../../../style/Leaveorduty.css";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const ProcessLeaveListDetails = ({
  empTask,
  employeelist,
  loadtask,
  selectedEmployeeId,
  handelFromDate,
  handelToDate,
  fromDate,
  toDate,
  reloaddata
}) => {

  const [activeTab, setActiveTab] = useState("Pending");
  const [filteredList, setFilteredList] = useState([]);
  const [search, setSearch] = useState("");
  const [leaveTypeFilter, setLeaveTypeFilter] = useState("All");
  const [selectedRows, setSelectedRows] = useState([]);
  const [rejectModal, setRejectModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [singleApproveModal, setSingleApproveModal] = useState(false);
  const [singleRejectModal, setSingleRejectModal] = useState(false);
  const [singleId, setSingleId] = useState(0);
  const [singleComment, setSingleComment] = useState("");
  const [comment, setComment] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [error, setError] = useState(null);
const [baseFilteredList, setBaseFilteredList] = useState([]);
  const INPUT_HEIGHT = 44;
  const DarkBackground = styled.div`
    display: none;
    position: fixed;
    inset: 0;
    z-index: 999;
    background: rgba(0,0,0,.4);
    ${props => props.show && css`display:block;`}
  `;

  const isRowEnabled = row =>
    row.leaveStatus === "Pending" || row.leaveStatus === "Rejected";

 const pendingCount  = baseFilteredList.filter(x => x.leaveStatus === "Pending").length;
const approvedCount = baseFilteredList.filter(x => x.leaveStatus === "Approved").length;
const rejectedCount = baseFilteredList.filter(x => x.leaveStatus === "Rejected").length;
const allCount = baseFilteredList.length;

useEffect(() => {
  let list = empTask;

  // SEARCH
  if (search) {
    list = list.filter(x =>
      x.employeeName?.toLowerCase().includes(search.toLowerCase()) ||
      x.employeeCode?.includes(search)
    );
  }

  // LEAVE TYPE
  if (leaveTypeFilter !== "All") {
    list = list.filter(x => x.type === leaveTypeFilter);
  }

  // FROM DATE
  if (fromDate) {
    list = list.filter(x =>
      moment(x.fromDate).isSameOrAfter(moment(fromDate), "day")
    );
  }

  // TO DATE
  if (toDate) {
    list = list.filter(x =>
      moment(x.toDate).isSameOrBefore(moment(toDate), "day")
    );
  }

  setBaseFilteredList(list);
}, [empTask, search, leaveTypeFilter, fromDate, toDate]);
const leaveOptions = [
  { value: "All", label: "All Leave Types" },
  ...Array.from(
    new Map(
      leaveTypes
        .filter(x => x.requestType === "Leave") // ✅ only Leave
        .map(x => [x.type, x])                  // ✅ remove duplicates by type
    ).values()
  ).map(x => ({
    value: x.type,
    label: x.type
  }))
];

useEffect(() => {
  let list = baseFilteredList;

  if (activeTab !== "All") {
    list = list.filter(x => x.leaveStatus === activeTab);
  }

  setFilteredList(list);
  setSelectedRows([]);
}, [baseFilteredList, activeTab]);

  useEffect(() => {
    const fetchLeaveTypes = async () => {
      const response = await api.dbLeaveTypes().GetLeaveTypes();
      setLeaveTypes(response.data || []);
    };
    fetchLeaveTypes();
  }, []);

  const toggleSelectAll = (e) => {
    if (!e.target.checked) return setSelectedRows([]);

    const enabledIds = filteredList
      .filter(isRowEnabled)
      .map(x => x.leaveRequestId);

    setSelectedRows(enabledIds);
  };

  const toggleRow = (row) => {
    if (!isRowEnabled(row)) return;

    setSelectedRows(prev =>
      prev.includes(row.leaveRequestId)
        ? prev.filter(x => x !== row.leaveRequestId)
        : [...prev, row.leaveRequestId]
    );
  };
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: INPUT_HEIGHT,
    height: INPUT_HEIGHT,
    borderRadius: "10px",
    borderColor: "#2bb3a6",
    boxShadow: "none",
    '&:hover': {
      borderColor: "#2bb3a6",
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: INPUT_HEIGHT,
    padding: "0 12px",
    display: "flex",
    alignItems: "center"
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: INPUT_HEIGHT,
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "14px",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "14px",
  }),
};


  const bulkApprove = async () => {
    setLoaded(true);
    for (let id of selectedRows) {
      await api.dbCalendarYear().ApproveLeaveRequest(id, 2, "");
    }
    setLoaded(false);
    setSelectedRows([]);
    setApproveModal(false);
    reloaddata();
  };

  const singleApprove = async () => {
    setLoaded(true);
    await api.dbCalendarYear().ApproveLeaveRequest(singleId, 2, "");
    setLoaded(false);
    setSingleApproveModal(false);
    setSingleId(0);
    reloaddata();
  };

  const singleReject = async () => {
    setLoaded(true);
    await api.dbCalendarYear().RejectLeaveRequest(singleId, 3, singleComment);
    setLoaded(false);
    setSingleRejectModal(false);
    setSingleId(0);
    setSingleComment("");
    reloaddata();
  };

  const handleSaveForm =React.useCallback((leaverequestId) =>{
    setSingleId(leaverequestId);
    setSingleApproveModal(true);
     })
       const handleRejectForm =React.useCallback((leaverequestId) =>{
    setSingleId(leaverequestId);
    setSingleRejectModal(true);
     })


  return (
    <Fragment>

      <div id="datepicker-portal">
<div className="d-flex justify-content-between align-items-center p-3 text-white headtab" style={{ background: "#0f9d8a" }}>
          <h4 className="mb-0">Leave Approval</h4>
          </div>

<div className="leave-tabs">
  {[
  { k: "Pending",  l: "Pending Requests",  c: pendingCount },
  { k: "Approved", l: "Approved",          c: approvedCount },
  { k: "Rejected", l: "Rejected",          c: rejectedCount },
  { k: "All",      l: "All Requests",      c: allCount }
]
.map(t=>(
    <div key={t.k}
      className={`leave-tab-item ${activeTab===t.k?"active":""}`}
      onClick={()=>setActiveTab(t.k)}>
      {t.l} ({t.c})
    </div>
  ))}
</div>
<div className="leave-filter-bar">

  {/* Search */}
  <Input
    className="leave-search"
    placeholder="Search by name..."
    value={search}
    onChange={e => setSearch(e.target.value)}
  />

  {/* Employee */}
  {/* <div className="filter-item">
    <SelectBoxSearch
      options={[{ id: "all", label: "All Employees" }, ...employeelist]}
      selectedUser={selectedEmployeeId}
      onChange={e => loadtask(e.id === "all" ? "all" : e)}
    />
  </div> */}

  {/* Leave Type */}
  <div className="filter-item">
    <Select
     options={leaveOptions}
      value={{
        value: leaveTypeFilter,
        label: leaveTypeFilter === "All" ? "All Leave Types" : leaveTypeFilter
      }}
      onChange={e => setLeaveTypeFilter(e.value)}
      styles={customStyles}
       classNamePrefix="leave-select"
      placeholder="Leave Type"
    />
  </div>

  {/* From Date */}
  <div className="filter-item">
    <DatePicker
      selected={fromDate ? new Date(fromDate) : null}
      onChange={handelFromDate}
      dateFormat="dd-MM-yyyy"
      className="custom-green-datepicker common-filter-input"
      placeholderText="From date"
      popperPlacement="bottom-start"
   portalId="datepicker-portal"
      
    />
  </div>

  {/* To Date */}
  <div className="filter-item">
    <DatePicker
      selected={toDate ? new Date(toDate) : null}
      onChange={handelToDate}
      dateFormat="dd-MM-yyyy"
      className="custom-green-datepicker common-filter-input"
      placeholderText="To date"
        /* ✅ IMPORTANT */
  minDate={fromDate ? new Date(fromDate) : null}

      popperPlacement="bottom-start"
      popperPositionFixed     // ⭐ VERY IMPORTANT
 portalId="datepicker-portal"      // ⭐ RENDER OUTSIDE
    />
  </div>

</div>

{selectedRows.length > 0 && (
  <div className="bulk-action-bar button-newspaceissue" style={{justifyContent: 'flex-end'}}>
    <Button color="success" onClick={()=>setApproveModal(true)}>Approve Selected</Button>
    {/* <Button color="danger" onClick={()=>setRejectModal(true)}>Reject Selected</Button> */}
  </div>
)}

<table className="table">
<thead>
<tr>
<th className="checkbox-col">
<Input type="checkbox"
  checked={
    filteredList.filter(isRowEnabled).length>0 &&
    selectedRows.length===filteredList.filter(isRowEnabled).length
  }
  onChange={toggleSelectAll}/>
</th>
<th>Employee</th><th>Leave Type</th><th>Applied On</th><th>From</th>
<th>To</th><th>Days</th><th>Reason</th><th>Status</th><th>Actions</th>
</tr>
</thead>

<tbody>
{filteredList.map(row=>{
const enabled=isRowEnabled(row);
return(
<tr key={row.leaveRequestId}>
<td className="checkbox-col">
<Input type="checkbox"
  disabled={!enabled}
  checked={selectedRows.includes(row.leaveRequestId)}
  onChange={()=>toggleRow(row)} />
</td>
<td>{row.employeeName}</td>
<td>{row.type}</td>
<td>{moment(row.createdDate).format("DD MMM YYYY")}</td>
<td>{moment(row.fromDate).format("DD MMM YYYY")}</td>
<td>{moment(row.toDate).format("DD MMM YYYY")}</td>
<td>{row.noOfDays}</td>
<td>{row.reason}</td>
<td>
  <span style={{
    backgroundColor: row.leaveStatus === "Approved" ? "#28a745" : row.leaveStatus === "Pending" ? "#ffc107" : "#dc3545",
    color: "white",
    padding: "4px 10px",
    borderRadius: "15px",
    fontSize: "12px"
  }}>
    {row.leaveStatus}
  </span>
</td>
<td>
<td className="button-newspaceissue">
  <Button
    size="sm"
    color="success"
    className="me-2"
    disabled={
      !isRowEnabled(row) ||
      selectedRows.includes(row.leaveRequestId)
    }
     onClick={() => handleSaveForm(row.leaveRequestId)}
    >
    ✓
  </Button>

  <Button
    size="sm"
    color="danger"
    className="ms-2"
    disabled={
      !isRowEnabled(row) ||
      selectedRows.includes(row.leaveRequestId)
    }
     onClick={() => handleRejectForm(row.leaveRequestId)}
    >
    ✕
  </Button>
</td>

</td>
</tr>
)})}
</tbody>
</table>

<Modal isOpen={approveModal}>
<ModalBody>
Are you sure you want to approve selected items?
</ModalBody>
<ModalFooter>
<Button onClick={()=>setApproveModal(false)}>Cancel</Button>
<Button color="success" onClick={bulkApprove}>Approve</Button>
</ModalFooter>
</Modal>

<Modal isOpen={singleApproveModal}>
<ModalBody>
Are you sure you want to approve this request?
</ModalBody>
<ModalFooter>
<Button onClick={()=>setSingleApproveModal(false)}>Cancel</Button>
<Button color="success" onClick={singleApprove}>Approve</Button>
</ModalFooter>
</Modal>

<Modal isOpen={singleRejectModal}>
<ModalBody>
<Input type="textarea" value={singleComment}
onChange={e=>setSingleComment(e.target.value)} placeholder="Enter reason for rejection" />
</ModalBody>
<ModalFooter>
<Button onClick={()=>setSingleRejectModal(false)}>Cancel</Button>
<Button color="danger" onClick={singleReject}>Reject</Button>
</ModalFooter>
</Modal>

<Notifications notifications={error}/>
<DarkBackground show={loaded}>
<LoadingOverlay active spinner text="Processing..."/>
</DarkBackground>
</div>

</Fragment>
);
};

export default ProcessLeaveListDetails;
